import { FC } from "react";
import { Icon, IconProps } from "./components/Icon";

const Minus: FC<IconProps> = ({ ...props }) => {
  return <Icon {...props} d="M19 13H5v-2h14v2z" />;
};

export { Minus };
